import { useParams } from "@tanstack/react-router";
import PosteViewPage from "@features/creation/postes/components/PosteViewPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/creation/postes/$id/view")({
  loader: requirePermission(PERMISSIONS.CREATION.POSTES.VIEW),
  staticData: {
    title: "Détail poste",
    icon: Eye,
    permission: PERMISSIONS.CREATION.POSTES.VIEW,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: ViewPostePage,
});

function ViewPostePage() {
  const { id } = useParams({ from: "/_app/creation/postes/$id/view" });
  return <PosteViewPage id={id} />;
}
